export default "__VITE_ASSET__CkVchYr1__"